import React, {useEffect} from 'react';
import CreateParcelForm from "../parcels/form_v3/createParcelForm";
import CalcHeader from "../../containers/header/calcHeader";

const Calc = ({history, match}) => {
    useEffect(() => {
        (function (m, e, t, r, i, k, a) {
            m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
            m[i].l = 1 * new Date();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
        })
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        ym(55485361, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
        });
    }, []);

    const v2 = match.path.includes('calc2');
    return (
        <div>
            <CalcHeader/>
            <CreateParcelForm
                history={history}
                isCalc
                isCalcV2={v2}
            />
        </div>
    );
};

export default Calc;


// WEBPACK FOOTER //
// ./App/pages/calc/calc.jsx